import { render, staticRenderFns } from "./Erp6SaleCollection.vue?vue&type=template&id=ed98a734&scoped=true&"
import script from "./Erp6SaleCollection.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleCollection.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleCollection.vue?vue&type=style&index=0&id=ed98a734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed98a734",
  null
  
)

export default component.exports